/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const permissions = currentUser?.permissions || {};

  return {
    ...permissions,
    canAccess: (route: { access?: string }) => {
      if (!route.access) return true;
      return !!permissions[route.access];
    },
    canDo: (permission: string) => !!permissions[permission],
  } as Record<string, boolean | ((...args: any[]) => boolean)>;
}
